'use client'

import { useEffect } from 'react'

import { syncBuyLegacyVenueGroup } from '@lib/posthog'
import type { Venue } from 'types/model/venue'

export function PostHogVenueGroupSync({ venue }: { venue: Venue }): null {
  // biome-ignore lint/correctness/useExhaustiveDependencies: syncBuyLegacyVenueGroup is a client-side function and should not be called in a loop
  useEffect(() => {
    syncBuyLegacyVenueGroup(venue)
  }, [venue.id])

  return null
}
